export enum DeepResearchMessageType {
  USER_MESSAGE = 'USER_MESSAGE',
  SYSTEM_REPORT = 'SYSTEM_REPORT',
  PROGRESS = 'PROGRESS',
}
